import React, { useEffect, useState } from "react";
import { Alert, Button, Form, Modal, Spinner } from "react-bootstrap";
import { getAllApplications, getAllDomains, updateInfoToUser } from "../../helpers/api";
import { getUser } from "../../helpers/localStorage";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const configSystem = require("../../configApp");

export default function UpdateApplications({
  show,
  onCancel,
  onClose,
  onSuccess,
  onFail,
  userDefault
}) {
  const defaultApplications = userDefault.applications;
  const defaultDomains = userDefault.domains || [];
  const [user, setUser] = useState({
    applications: [],
    domains: [],
    dueDate: ""
  });
  const [applications, setApplications] = useState({"applications":[]});
  const [domains, setDomains] = useState([]);

  // Las aplicaciones reservadas solo las ve el Super Admin. Si el cliente ya
  // tiene alguna, el servidor se la conserva aunque no aparezca en esta lista.
  const esSuperAdmin = getUser().type === configSystem.roles.SUPER_ADMIN;
  const reservadas = configSystem.superAdminOnlyApplications || [];
  const aplicacionesVisibles = (applications.applications || []).filter(
    (a) => esSuperAdmin || !reservadas.includes(Number(a.id))
  );
  const [dueDateRise, setDueDateRise] = useState("0");

  const [showLoading, setShowLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [connectionError, setConnectionError] = useState("");
  useEffect(() => {
    setConnectionError("");
    setShowSuccess(false);
  }, [user]);

  useEffect(()=>{
          getAllApplications().then((data)=>{
            setApplications(data);
          }).catch((e)=>{
            console.log(e);
          });
          
          getAllDomains().then((data)=>{
            if (data && data.domains && Array.isArray(data.domains)) {
              setDomains(data.domains);
            } else {
              setDomains([]);
            }
          }).catch((e)=>{
            console.log(e);
            setDomains([]);
          });
      },[]);

  useEffect(() => {
    setUser({
      applications: userDefault.applications,
      domains: userDefault.domains || [],
      dueDate: userDefault.dueDate
    });
  }, [show, userDefault.applications, userDefault.domains]);

  useEffect(()=>{
    if(dueDateRise !== ""){
      let date;
      if(moment().isAfter(moment(userDefault.dueDate))){
          date = moment().add(dueDateRise, "M").toDate();
      }else{
          date = moment(userDefault.dueDate).add(dueDateRise, "M").toDate();
      }
      updateUserInfo({ ...user, dueDate: date });
    }
    
  },[dueDateRise]);

  useEffect(() => {
    const validateInfo = () => {
      let errorInfo = {
        foundError: false,
        applications: ""
      };


      if (typeof user.applications === "undefined" || user.applications.length === 0){
        errorInfo.foundError = true;
        errorInfo.applications = "No selected applications"

      }

      setErrors(errorInfo);
    };
    validateInfo();
  }, [user]);

  const [errors, setErrors] = useState({
    foundError: false,
    applications: ""
  });

  const updateUserInfo = (info) => {
    const data = { ...user, ...info };
    setUser(data);
  };

  const clearBeforeClose = () =>{
    updateUserInfo({ ...user, applications: defaultApplications, domains: defaultDomains }); //clear
  }

  const handlerSelectedApplication = (e)=> {
    e.preventDefault();
    let app = [];
    for (var i = 0, l = e.target.options.length; i < l; i++) {
      if (e.target.options[i].selected) {
        app.push(e.target.options[i].value);
      }
    }
  
    updateUserInfo({ ...user, applications: app });

  };

  // Alterna una aplicacion con un clic (agrega o quita). Reemplaza al
  // <select multiple>, que era facil de "seleccionar de mas".
  const toggleApplication = (id) => {
    const actuales = (user.applications || []).map(Number);
    const nid = Number(id);
    const nuevas = actuales.includes(nid)
      ? actuales.filter((x) => x !== nid)
      : [...actuales, nid];
    updateUserInfo({ ...user, applications: nuevas });
  };

  const handlerSelectedDomains = (e)=> {
    e.preventDefault();
    let domainIds = [];
    for (var i = 0, l = e.target.options.length; i < l; i++) {
      if (e.target.options[i].selected) {
        domainIds.push(e.target.options[i].value);
      }
    }
  
    updateUserInfo({ ...user, domains: domainIds });
    
  };

  const handleDueDate = (date) => {
    updateUserInfo({ ...user, dueDate: date });
  }

  const handleDueDateRise = (e) => {
    e.preventDefault();
    setDueDateRise(e.target.value);
  };

  const saveUser = (e) => {
    e.preventDefault();
    if (!errors.foundError) {
      setShowLoading(true);
      updateInfoToUser(userDefault, user)
        .then((response) => {
          setShowLoading(false);
          setShowSuccess(true);
          if (onSuccess) {
            onSuccess();
          }
        })
        .catch((error) => {
          setShowLoading(false);
          setConnectionError(error);
          setShowSuccess(false);
          if (onFail) {
            onFail();
          }
        });
    }
  };
  const form = () => {
    return (
      <>
        <Form.Group className="mb-3">
          <Form.Label>Applications</Form.Label>
          <span style={{ color: "red" }}>{errors.applications}</span>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", maxHeight: "240px", overflowY: "auto", padding: "10px", border: "1px solid #e2e8f0", borderRadius: "10px", background: "#f8fafc" }}>
            {aplicacionesVisibles.length === 0 && (
              <span style={{ color: "#94a3b8", fontSize: "0.85rem" }}>Cargando aplicaciones…</span>
            )}
            {aplicacionesVisibles.map((option) => {
              const activa = (user.applications || []).map(Number).includes(Number(option.id));
              return (
                <button
                  type="button"
                  key={option.id}
                  onClick={() => toggleApplication(option.id)}
                  aria-pressed={activa}
                  title={activa ? "Quitar " + option.tittle : "Agregar " + option.tittle}
                  style={{
                    display: "inline-flex", alignItems: "center", gap: "7px",
                    padding: "7px 14px", borderRadius: "999px",
                    border: "1.5px solid " + (activa ? "#16a34a" : "#cbd5e1"),
                    background: activa ? "#dcfce7" : "#ffffff",
                    color: activa ? "#166534" : "#334155",
                    fontSize: "0.85rem", fontWeight: activa ? 600 : 500,
                    cursor: "pointer", transition: "all .15s",
                  }}
                >
                  <span style={{ fontWeight: 700 }}>{activa ? "✓" : "+"}</span>
                  {option.tittle}
                </button>
              );
            })}
          </div>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Additional Domains</Form.Label>
          <Form.Control as="select" multiple value={user.domains} onChange={handlerSelectedDomains} >
            {(Array.isArray(domains) ? domains : []).filter(d => d.enabled).map((domain) => (
              <option key={domain._id} value={domain._id}>
                {domain.name}   
              </option>
            ))}  
          </Form.Control>
          <Form.Text className="text-muted">
            Hold Ctrl (Windows) or Cmd (Mac) to select multiple domains
          </Form.Text>
        </Form.Group>

        <Form.Group className="m-3">
          <Form.Label>Due Date</Form.Label><br/>
          <DatePicker
                selected={user.dueDate}
                onChange={(date) => handleDueDate(date)}
                highlightDates={[moment(user.dueDate)]}
                isClearable={true}
              />
          <select value={dueDateRise} onChange={handleDueDateRise}>
                <option value="0"></option>
                <option value="1">1 Month</option>
                <option value="2">2 Months</option>
                <option value="3">3 Month</option>
                <option value="4">4 Months</option>
                <option value="5">5 Month</option>
                <option value="6">6 Months</option>
                <option value="7">7 Month</option>
                <option value="8">8 Months</option>
                <option value="9">9 Month</option>
                <option value="10">10 Months</option>
                <option value="11">11 Month</option>
                <option value="12">1 Years</option>
              </select>
        </Form.Group>
      </>
    );
  };

  return (
    <Modal show={show} onHide={()=>{clearBeforeClose();onCancel()}} animation={false} centered={true}>
      <Modal.Header closeButton>
        <Modal.Title>{`Update Applications For ${userDefault.username}`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {connectionError !== "" ? (
          <Alert variant="warning">{connectionError}</Alert>
        ) : (
          <></>
        )}
        {showSuccess ? (
          <Alert variant="success">Applications Updated!</Alert>
        ) : (
          <></>
        )}
        {form()}
      </Modal.Body>
      <Modal.Footer>
        {!showSuccess ? (
          <>
            <Button
              variant="secondary"
              onClick={() => {
                clearBeforeClose();
                onCancel();
              }}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={saveUser} disabled={showLoading}>
              {showLoading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <></>
              )}
              Save
            </Button>
          </>
        ) : (
          <Button
            variant="secondary"
            onClick={() => {
              clearBeforeClose();
              onCancel();
            }}
          >
            Close
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
